module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/faq-components/detail-faq-category/detail-faq-category.component.scss
// module id = ./src/app/faq-components/detail-faq-category/detail-faq-category.component.scss
// module chunks = main